import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
	type SiteConfig,
	siteApi,
	type UpdateSiteConfigPayload,
} from "@/lib/site/site-api";

export const useSiteConfig = () =>
	useQuery({
		queryKey: ["site", "config"],
		queryFn: siteApi.getConfig,
		staleTime: 10_000,
	});

export const useUpdateSiteConfig = () => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (patch: UpdateSiteConfigPayload) => siteApi.updateConfig(patch),
		onSuccess: (cfg: SiteConfig) => {
			qc.setQueryData(["site", "config"], cfg);
		},
	});
};

export const useLaunchSubscribers = () =>
	useQuery({
		queryKey: ["launch", "subscribers"],
		queryFn: siteApi.subscribers,
		staleTime: 30_000,
	});
